import { useParams, useNavigate } from "react-router-dom";
import { getSlugDetails } from "../../productStore";
import StoreData from "./StoreData";
import classes from "./StoreData.module.css";
import Header from "../Header&Footer/Header";
import { Fragment } from "react";

const StoreDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const slug = params.storeId;

  const storeDetails = getSlugDetails(slug);
  if (!storeDetails) {
    return navigate("/store", { replace: true });
  }
  return (
    <Fragment>
      <Header />
      <section className={classes.section}>
        <ul className={classes.lister}>
          <StoreData product={storeDetails} />
        </ul>
      </section>
    </Fragment>
  );
};
export default StoreDetails;
